import * as Sentry from '@sentry/react';
import { sentryConfig } from 'config/sentry';
import { replayPrivacy } from 'utils/analytics/replayPrivacy';

if (sentryConfig.enabled) {
  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
    release: sentryConfig.release,
    debug: sentryConfig.debug,
    tracesSampleRate: sentryConfig.tracesSampleRate,
    integrations: [
      Sentry.browserTracingIntegration(),
      ...(sentryConfig.replayEnabled
        ? [
            Sentry.replayIntegration({
              maskAllText: false,
              maskAllInputs: false,
              blockAllMedia: false,
              // FormField keeps this class when "Show password" changes the input type.
              mask: ['.password-input input'],
              networkCaptureBodies: false,
              // A reload starts a new replay, so a stored session cannot cross accounts.
              stickySession: false,
            }),
          ]
        : []),
    ],
    replaysSessionSampleRate: sentryConfig.replayEnabled ? sentryConfig.sessionSampleRate : 0,
    replaysOnErrorSampleRate: sentryConfig.replayEnabled ? sentryConfig.errorSampleRate : 0,
  });
  if (sentryConfig.replayEnabled) Sentry.addEventProcessor(replayPrivacy.filterEvent);
}
